module.exports = new __parcel__URL__("Charlie_Display-Ultra_Italic.2f7484ec.woff2").toString();